import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./app.scss";
import { DatasPage } from "./pages/datas";

/* -------------------------------------------------------------------------------- *\
|                               App
\* -------------------------------------------------------------------------------- */
export default function App()
{
    return (
        <BrowserRouter basename="/">
            <Routes>
                <Route path="/" element={<DatasPage />} />
            </Routes>
        </BrowserRouter>
    );
}
